/**
 * @file: leadCovered.ts
 *
 * One rule for "this plan detail already belongs to a lead", shared by the
 * lead affordance button (which flips its label to 查看商机) and the feed
 * reminder body (which clears its own unread state off the same answer).
 * Keeping both on one predicate is the point: a card that offers 查看商机
 * must never still be asking to be marked as read.
 *
 * `consumed` counts as covered — the detail was handed to a lead that has
 * since closed; the reminder was acted on either way, and the button still
 * links to that lead.
 */

import { LeadCoverageInfo } from '@euler/model/lead/types';

export function isCoveredByLead(
  coverage: LeadCoverageInfo | undefined,
): boolean {
  return (
    coverage != null && coverage.coverage !== 'uncovered' && !!coverage.leadId
  );
}
